<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">{{formatType(type).title}}</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">{{formatType(type).value}}</span>
			<div class="inner-btn" @click="changeType">
				{{type=='list'?'添加文件':'返 回'}}
			</div>
		</div>
		<FileList ref="list" v-if="type==='list'" @toEdit="toEdit"></FileList>
		<AddFile v-if="type==='add'" @back="back" ></AddFile>
		<EditFile v-if="type==='edit'" @back="back" :id="id"></EditFile>
	</div>
</template>

<script>
	import FileList from '../../components/file/FileList.vue'
	import AddFile from '../../components/file/AddFile.vue'
	import EditFile from '../../components/file/EditFile.vue'
	let types = {
		list: {
			title: '文件列表',
			value: 'file list'
		},
		add: {
			title: '新增文件',
			value: 'add file'
		},
		edit: {
			title: '修改文件',
			value: 'edit file'
		}
	}
	export default {
		components: {
			FileList,
			AddFile,
			EditFile
		},
		data() {
			return {
				type: 'list',
				id: null
			}
		},
		filters: {
			formatType(value) {
				return types[value]
			}
		},

		methods: {
			formatType(value) {
				return types[value]
			},
			changeType() {
				if (this.type === 'add' || this.type === 'edit') {
					this.type = 'list'
				} else {
					this.type ='add'
				}
				console.log(this.type)
			},
			back() {
				this.type = 'list'
				setTimeout(() => {
					this.$refs.list.search()
				}, 500)

			},
			toEdit(id) {
				this.id = id
				setTimeout(() => {
					this.type = 'edit'
				}, 500)
				
			}
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}

	.page .container-fluid .inner-btn {
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor: pointer;
	}
	.page .container-fluid .inner-btn:hover{
		background-color: #9a9a9a;
	}
</style>